import React from 'react';

import './Main.scss';

export default function Main() {
    return (
        <div className="main-container">
            <div className="main-container__heading">
                <h3>This page will soon be updated with useful information</h3>
            </div>
            <div className="main-container__fun-pic" />
        </div>
    );
}
